import React, { type FunctionComponent } from 'react'
import { ReportRequestStateEnum } from '__codegen__/api'
import { useDashIntl } from 'intl/intl.hooks'
import { DashButton } from 'legacy/dash-blocks/dash-button/DashButton'
import {
  generateButtonProps,
  statusButtonLabels,
  STATUS_BUTTON_STYLE,
} from 'legacy/dash-components/status-button/utils/statusButton.utils'

interface Props {
  status: ReportRequestStateEnum
  onClick?: () => void
}

export const StatusButton: FunctionComponent<Props> = ({ status, onClick }) => {
  const intl = useDashIntl()
  const label = intl.formatMessage({ id: statusButtonLabels[status] })
  const styleProps = generateButtonProps(status)
  const isInteractive = status === ReportRequestStateEnum.Complete

  if (isInteractive) {
    return (
      <DashButton onClick={onClick} buttonStyle={STATUS_BUTTON_STYLE} size="small" {...styleProps}>
        {label}
      </DashButton>
    )
  }

  return (
    <DashButton buttonStyle={STATUS_BUTTON_STYLE} size="small" disabled {...styleProps}>
      {label}
    </DashButton>
  )
}
